(function() {
  var is_touch_device = ("ontouchstart" in window) || (window.DocumentTouch && document instanceof DocumentTouch);
  var currentCards = [];
  var currentIdx = -1;

  // On touch devices, intercept clicks on any element with data-card-image.
  // Works on any page (spoilers, decklist, etc.) — no page-specific logic here.
  document.addEventListener('click', function(e) {
    if (!is_touch_device) return;
    var card = e.target.closest('[data-card-image]');
    if (!card) return;
    // Let unofficial-blocker dismissals and source links pass through normally
    if (e.target.closest('.spoiler-card-unofficial-blocker')) return;
    if (e.target.closest('.spoiler-card-source')) return;
    e.preventDefault();
    openCardModal(card);
  });

  // Walk up one level to the parent container, query all [data-card-image]
  // siblings, and filter to only those visible in the DOM.
  // el.offsetParent !== null is reliable regardless of how hiding is done
  // (MixItUp display:none, CSS classes, anything).
  function getVisibleCards(card) {
    return Array.from(card.parentElement.querySelectorAll('[data-card-image]'))
      .filter(function(el) { return el.offsetParent !== null; });
  }

  function openCardModal(card) {
    currentCards = getVisibleCards(card);
    currentIdx = currentCards.indexOf(card);
    populateModal(card);
    bootstrap.Modal.getOrCreateInstance(document.querySelector('#card-popup-modal')).show();
  }

  function populateModal(card) {
    var qty = card.dataset.cardQuantity;
    var name = card.dataset.cardName;
    document.getElementById('card-popup-modal-title').textContent = qty ? (qty + 'x ' + name) : name;
    document.getElementById('card-popup-modal-image-container').innerHTML =
      "<img src='" + card.dataset.cardImage + "' class='price-card-image-image'>";
    document.getElementById('card-popup-modal-link').href = card.dataset.cardUrl;
    // Guard: modal body can be replaced externally, making these null.
    var prevBtn = document.getElementById('card-popover-prev-btn');
    var nextBtn = document.getElementById('card-popover-next-btn');
    if (prevBtn) prevBtn.classList.toggle('d-none', currentIdx === 0);
    if (nextBtn) nextBtn.classList.toggle('d-none', currentIdx === currentCards.length - 1);
  }

  document.addEventListener('DOMContentLoaded', function() {
    var prevBtn = document.getElementById('card-popover-prev-btn');
    var nextBtn = document.getElementById('card-popover-next-btn');
    var modal   = document.getElementById('card-popup-modal');
    if (!prevBtn || !nextBtn || !modal) return;

    prevBtn.addEventListener('click', function() {
      if (currentIdx > 0) { currentIdx--; populateModal(currentCards[currentIdx]); }
    });

    nextBtn.addEventListener('click', function() {
      if (currentIdx < currentCards.length - 1) { currentIdx++; populateModal(currentCards[currentIdx]); }
    });

    modal.addEventListener('hidden.bs.modal', function() {
      prevBtn.classList.add('d-none');
      nextBtn.classList.add('d-none');
    });
  });
})();
